import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CarruselDos({ children }) {
  const [clicked, setClicked] = useState(false);
  const handleMouseDown = () => {
    setClicked(true);
  };
  const handleMouseUp = () => {
    setClicked(false);
  };
  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: width >= 500 ? (width > 768 ? (width > 1024 ? 4 : 3) : 2) : 1,
    slidesToScroll: width >= 500 ? (width > 768 ? (width > 1024 ? 4 : 3) : 2) : 1,
    initialSlide: 0,
  };
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      className={`w-full overflow-hidden ${clicked ? "cursor-grabbing" : "cursor-grab"} pb-5 `}
    >
      <Slider {...settings}>
        {children.map((item, index) => {
          return (
            <div key={index} className="p-4 pb-10">
              {item}
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default CarruselDos;
